export default __webpack_public_path__ + "static/media/roebling-block-party.9952540a.png";